module.exports = __webpack_public_path__ + "static/media/20_tn.c89f231d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/20_tn.jpg
// module id = 329
// module chunks = 0